import Vue from "vue"
import Router from "vue-router"
import GetToken from "@/views/default/GetToken"
import Welcome from "@/views/default/Welcome"
import Error from "@/views/default/Error"
import AdminMaintain from "@/views/admin/AdminMaintain"
import { store } from "@/store/store.js"
import * as types from "@/store/mutations_types.js"
import { getCookie, setCookie, delCookie } from "@/utils/cookie"
import { api } from "@/utils/api"
import { utils } from "@/utils/utils.js"
import PageLogin from "@/views/PageLogin.vue"
import PageNoPermission from "@/views/PageNoPermission.vue"
import reserve from "./modules/reserve.js"
import maintain from "./modules/maintain.js"
import release from "./modules/release.js"
import { map, omit } from "lodash"

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: "/getToken",
      name: "GetToken",
      component: GetToken,
    },
    {
      path: "/",
      name: "Welcome",
      component: Welcome,
    },
    {
      path: "/401",
      name: "NoAuthorized",
      component: Error,
    },
    {
      path: "/error",
      name: "Error",
      component: Error,
    },
    {
      path: "*",
      name: "NotFoundUrl",
      component: Error,
    },
    {
      path: "/Login",
      name: "PageLogin",
      component: PageLogin,
      props: true,
    },
    {
      path: "/nopermission",
      name: "PageNoPermission",
      component: PageNoPermission,
    },
    {
      path: "/AdminMaintain",
      name: "AdminMaintain",
      component: AdminMaintain,
    },
    ...reserve,
    ...release,
    ...maintain,
  ],
})

router.beforeEach((to, from, next) => {
  if (to.query.token) {
    setCookie(process.env.VUE_APP_AUTH_TOKEN_NAME, to.query.token, 1000 * 60 * 60 * 6)
    store.commit(types.LOGIN, true)
    store.commit(types.REDIRECT_URL, to.path)
    next({
      path: "/",
    })
  }
  if (!store.getters.getUserInfoThrowError && getCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)) {
    store.commit(types.LOGIN, true)
    localStorage.setItem("loginAuthCount", 0)
    if (JSON.stringify(store.getters.getUserProfile) == "{}") {
      var userTask = api.apiGetCurrentUser()
      var codeCultureTask = api.apiGetCodeCultures()

      Promise.all([userTask, codeCultureTask]).then((values) => {
          store.dispatch("setUserInfoThrowError", false)
          //todo:alter name of property in api
          let areas = values[0].data.areaRoleRights.map((a) => a.area)
          let userData = {
            userAD: values[0].data.userNT,
            userEmail: values[0].data.userMail,
            userPhone: values[0].data.userPhone,
            userName: values[0].data.userName,
            userDept: values[0].data.userDept,
            userEmpID: values[0].data.userID,
            userLoginRole: values[0].data.systemRoles ?? [],
            functionAreas: values[0].data.functionMappingAreas,
            factory: null,
            area: values[0].data.isAdmin ? null : areas,
            region: values[0].data.isAdmin ? null : values[0].data.region,
            isAdmin: values[0].data.isAdmin,
            isApprovalRole: values[0].data.isApprovalRole,
            areaRights: values[0].data.isAdmin
              ? null
              : map(values[0].data.areaRoleRights, function (n) {
                  return omit(n, "roleList")
                }),
            menu: values[0].data.menu,
            systemFunctions: values[0].data.systemFunctions,
          }
          userData.enableAreaSelection = userData.isAdmin || areas?.length > 1
          store.dispatch("setUserProfile", userData)

          store.dispatch("setCodeCulture", values[1].data)
        })
        .then(() => {
          const haveAuth = store.getters.getUserProfile.systemFunctions.some((menu) => {
            return to.name?.includes(menu)
          })
          if (to.name === "Welcome") {
            if ((store.getters.getUserProfile.systemFunctions ?? []).length === 0) {
              next({ name: "NoAuthorized" })
            } else {
              if (sessionStorage.getItem("auto_redirect") !== null) {
                let toPath = sessionStorage.getItem("auto_redirect")
                //不知道為什麼會執行兩次,先用這個解法
                if (sessionStorage.getItem("auto_redirect_call") !== null) {
                  sessionStorage.removeItem("auto_redirect")
                  sessionStorage.removeItem("auto_redirect_call")
                } else {
                  sessionStorage.setItem("auto_redirect_call", "TRUE")
                }
                next(toPath)
              } else {
                let defaultFunction = store.getters.getUserProfile.systemFunctions[0]
                setFunctionAreas(defaultFunction)
                next({ name: defaultFunction })
              }
            }
          }
          if (
            to.name === "" ||
            to.name === "GetToken" ||
            to.name === "NoAuthorized" ||
            to.name === "NotFoundUrl" ||
            to.name === "Welcome" ||
            to.name === "PageLogin" ||
            haveAuth ||
            (store.getters.getUserProfile.isAdmin && to.name === "AdminMaintain")
          ) {
            setFunctionAreas(to.name)
            next()
          } else {
            if ((store.getters.getUserProfile.systemFunctions ?? []).length === 0) {
              next({ name: "NoAuthorized" })
            } else {
              let defaultFunction = store.getters.getUserProfile.systemFunctions[0]
              setFunctionAreas(defaultFunction)
              next({ name: defaultFunction })
            }
          }
        })
        .catch((error) => {
          delCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
          store.dispatch("setLogin", false)
          store.dispatch("setUserInfoThrowError", true)
          console.log(error)
          next({ name: "NoAuthorized" })
        })
    } else {
      const haveAuth = store.getters.getUserProfile.systemFunctions.some((menu) => {
        return to.name?.includes(menu)
      })
      if (to.name === "Welcome") {
        if ((store.getters.getUserProfile.systemFunctions ?? []).length === 0) {
          next({ name: "NoAuthorized" })
        } else {
          let defaultFunction = store.getters.getUserProfile.systemFunctions[0]
          setFunctionAreas(defaultFunction)
          next({ name: defaultFunction })
        }
      }
      if (
        to.name === "" ||
        to.name === "GetToken" ||
        to.name === "NoAuthorized" ||
        to.name === "NotFoundUrl" ||
        to.name === "Welcome" ||
        to.name === "PageLogin" ||
        haveAuth ||
        (store.getters.getUserProfile.isAdmin && to.name === "AdminMaintain")
      ) {
        setFunctionAreas(to.name)
        next()
      } else {
        if ((store.getters.getUserProfile.systemFunctions ?? []).length === 0) {
          next({ name: "NoAuthorized" })
        } else {
          let defaultFunction = store.getters.getUserProfile.systemFunctions[0]
          setFunctionAreas(defaultFunction)
          next({ name: defaultFunction })
        }
      }
    }
  } else {
    let authnzURL = process.env.VUE_APP_AUTHNZ_HANDLER_URL
    let frontURL = process.env.VUE_APP_APP_URL
    if (to.name === "NoAuthorized" || to.name === "PageLogin") {
      next()
    } else {
      localStorage.setItem("loginAuthCount", Number(localStorage.getItem("loginAuthCount") ?? 0) + 1)
      store.commit(types.LOGIN, false)

      if (!utils.ValidateDeltaDomain(authnzURL)) {
        authnzURL = ""
        next({ name: "NoAuthorized" })
      }
      if (!utils.ValidateDeltaDomain(frontURL)) {
        frontURL = ""
        next({ name: "NoAuthorized" })
      }
      sessionStorage.setItem("auto_redirect", to.fullPath)
      if (Number(localStorage.getItem("loginAuthCount")) < 3) {
        window.location.href = authnzURL
      } else {
        localStorage.setItem("loginAuthCount", 0)
        next({ name: "PageLogin" })
      }
    }
  }
})

function setFunctionAreas(functionName) {
  let userData = store.getters.getUserProfile
  if (!userData.isAdmin && userData.functionAreas[functionName] !== undefined) {
    userData.area = userData.functionAreas[functionName].map((a) => a.area)
    userData.region = userData.functionAreas[functionName].map((a) => a.region)
    store.dispatch("setUserProfile", userData)
  }
}

export default router
